// extracted by mini-css-extract-plugin
module.exports = {"logo":"terms_logo__XCOZh","title":"terms_title__2BOhG","link":"terms_link__2rJSh","button":"terms_button__2K5gJ"};